import view from "../views/index";

const Remaining = () => {

    if (document.querySelector('#remaining-time__time')) {
        const strTime = (document.querySelector('#remaining-time__time').dataset && document.querySelector('#remaining-time__time').dataset.remainingTime) ? document.querySelector('#remaining-time__time').dataset.remainingTime : null;
        const endDate = new Date(strTime).getTime();

        const SECOND = 1000,
            MINUTE = SECOND * 60,
            HOUR = MINUTE * 60,
            DAY = HOUR * 24;

        const calculateAndResolveReminder = localRemaining => {
            const remainingTime = localRemaining;
            const endDateTimestamp = +remainingTime;

            if (endDateTimestamp - new Date().getTime() <= 0) document.querySelector('#remaining-time').remove();

            const populateRemainingTime = (initialTimestamp, finalTimestamp) => {
                const reminder = finalTimestamp - initialTimestamp,
                    d = Math.floor(reminder / (DAY)),
                    h = Math.floor((reminder % (DAY)) / (HOUR)),
                    m = Math.floor((reminder % (HOUR)) / (MINUTE)),
                    s = Math.floor((reminder % (MINUTE)) / (SECOND));
                view('REMAINING_TIME', [d, h, m, s]);
            };

            setInterval(() =>
                populateRemainingTime(new Date().getTime(), endDateTimestamp)
                , SECOND);
        };

        calculateAndResolveReminder(endDate);
    };
};

module.exports = {
    init: () => {
        Remaining();
    }
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/components/remaining.js